module.exports = __webpack_public_path__ + "img/footer_logo.a411fe17.png";